export default __webpack_public_path__ + "static/media/IMG_20210802_081324_551.e655c995.jpg";